var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLeafImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.827 141.188C187.298 108.851 149.422 94.1575 149.226 96.1922C143.302 156.888 153.525 184.963 153.525 184.963C141.073 160.61 140.286 102.675 140.286 102.675C84.8854 164.139 166.979 213.305 166.979 213.305C158.749 193.176 182.367 173.504 184.827 141.188Z",
    fill: "#87DA59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.713 129.099C119.898 118.524 126.041 108.132 135.153 98.0396L147.032 89.5239C148.033 89.1549 149.193 89.0154 150.479 89.1134C153.318 89.3604 158.576 91.2719 164.397 94.7584C165.902 95.6596 167.438 96.6875 168.991 97.7787C176.495 86.6422 179.574 76.7838 178.311 76.6463C89.1934 67.9589 47.9493 82.9662 47.9493 82.9662C83.7284 64.686 168.793 63.5207 168.793 63.5207C78.5397 -17.8381 6.33301 102.728 6.33301 102.728C35.8949 90.6509 64.7663 125.321 112.264 128.936C113.756 129.05 115.252 129.112 116.713 129.099Z",
    fill: "#87DA59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLeafImg);
export default __webpack_public_path__ + "static/media/right-leaf-img.85d4e5a13c85e0e03fd60f1426e518e7.svg";
export { ForwardRef as ReactComponent };